/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRecipe } from 'app/shared/model/recipe.model';

export interface INutrtion {
  id?: string;
  tmLabel?: string | null;
  tag?: string | null;
  description?: string | null;
  total?: number | null;
  rdi?: boolean | null;
  dailyTotal?: number | null;
  unit?: string | null;
  reciepe?: IRecipe | null;
}

export const defaultValue: Readonly<INutrtion> = {
  rdi: false,
};
